import { useEffect, useRef, useState } from 'react';
export const useStickyLabel = (value, minMs)=>{
    const [displayed, setDisplayed] = useState(value);
    const shownAtRef = useRef(value === undefined ? null : Date.now());
    const timerRef = useRef(null);
    useEffect(()=>{
        if (value === displayed) return;
        if (displayed === undefined) {
            setDisplayed(value);
            shownAtRef.current = value === undefined ? null : Date.now();
            return;
        }
        const elapsed = shownAtRef.current == null ? minMs : Date.now() - shownAtRef.current;
        const remaining = minMs - elapsed;
        if (timerRef.current != null) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (remaining <= 0) {
            setDisplayed(value);
            shownAtRef.current = value === undefined ? null : Date.now();
            return;
        }
        timerRef.current = setTimeout(()=>{
            timerRef.current = null;
            setDisplayed(value);
            shownAtRef.current = value === undefined ? null : Date.now();
        }, remaining);
    }, [
        value,
        displayed,
        minMs
    ]);
    useEffect(()=>()=>{
            if (timerRef.current != null) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        }, []);
    return displayed;
};
